import { isMobile } from '../isMobile';
// import { IAssetTrailer, ITrailer } from '../models';

// Injects trailers into items that are being displayed in the main page carousels
export const injectTrailers = (items, trailers) => {
  if (!trailers) {
    console.log('No trailers found: ', { items, trailers });
    return items;
  }
  return items.map((item) => {
    const assetTrailer = trailers.find((trailer) => trailer.id === item.id);

    return { ...item, assetTrailer };
  });
};

export const getTrailerUrl = (assetTrailer: any) => {
  if (!assetTrailer) {
    return null;
  }

  const { hls, dash, mp4 } = assetTrailer;

  // Use HLS Steam on Safari Only
  if (hls && isMobile.iOSDevice()) {
    return hls;
  }

  // Use DASH stream on all other browsers
  if (dash) {
    return dash;
  }

  // Use MPEG4 file as a fallback if the dash stream is not available
  if (!dash && mp4) {
    return mp4;
  }

  return null;
};

export const curations = {
  moviesTopVideoRentals: {
    name: 'Top Video Rentals',
    value: 'moviesTopVideoRentals',
  },
  moviesFree: {
    name: 'Free Movies',
    value: 'moviesFree',
  },
  kidsFreeMovies: {
    name: 'Kids - Free Movies',
    value: 'kidsFreeMovies',
  },
  premiumsMovies: {
    name: 'Premium Movies',
    value: 'premiumsMovies',
  },
  featuredBlackVoices: {
    name: 'Black Voices',
    value: 'featuredBlackVoices',
  },
  moviesAction: {
    name: 'Action',
    value: 'moviesAction',
  },
  moviesComedy: {
    name: 'Comedy',
    value: 'moviesComedy',
  },
  moviesDrama: {
    name: 'Drama',
    value: 'moviesDrama',
  },
  moviesRomance: {
    name: 'Romance',
    value: 'moviesRomance',
  },
  moviesSciFiAndFantasy: {
    name: 'Sci-Fi',
    value: 'moviesSciFiAndFantasy',
  },
  moviesThriller: {
    name: 'Thriller',
    value: 'moviesThriller',
  },
};
